
































import { Component, Vue, Prop } from 'vue-property-decorator';
import Masthead from './Common/Masthead.vue';
import SubNavigation from './Common/SubNavigation.vue';

@Component({
  components: {
    Masthead,
    SubNavigation,
  },
})
export default class SiteMasthead extends Vue {
  @Prop()
  private readonly mini!: boolean;

  @Prop()
  private readonly title!: string;

  @Prop()
  private readonly subtitle!: string;

  @Prop()
  private readonly image!: string;

  @Prop()
  private readonly darken!: boolean;

  @Prop()
  private readonly height!: string;

  // eslint-disable-next-line
  scrollToNext(): void {
    window.scroll({
      top: Math.round(window.innerHeight),
      left: 0,
      behavior: 'smooth',
    });
  }
}
